import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {Icon, Pagination} from 'semantic-ui-react'

class TablePagination extends Component {
    getTotalPage = (total_records, per_page) => {
        if (per_page > 0) {
            return Math.ceil(total_records / per_page);
        } else {
            return 1;
        }
    }

    _onPageChange = (e, data) => {
        this.props.goToPage(data.activePage);
    }
    
    render() {
        const {on_page, total_records, per_page} = this.props;
        return (
            <Pagination
                defaultActivePage={on_page}
                ellipsisItem={{ content: <Icon name='ellipsis horizontal' />, icon: true }}
                firstItem={{ content: <Icon name='angle double left' />, icon: true }}
                lastItem={{ content: <Icon name='angle double right' />, icon: true }}
                prevItem={{ content: <Icon name='angle left' />, icon: true }}
                nextItem={{ content: <Icon name='angle right' />, icon: true }}
                totalPages={this.getTotalPage(total_records, per_page)}
                onPageChange={this._onPageChange}
            />
        )
    }
}

TablePagination.propTypes = {
    on_page: PropTypes.number.isRequired,
    total_records: PropTypes.number.isRequired,
    per_page: PropTypes.number.isRequired,
    goToPage: PropTypes.func.isRequired
};

export default TablePagination


// WEBPACK FOOTER //
// ./src/components/utils/tables/TablePagination.js